module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4QoXDyEVfKyjNQAAALxJREFUWMPtV8ENxCAMi6MbhP2nYhP3FQlVAUrvCEhH3m3tOGlkg6SMFIDmCyQx8r3PKGhK6fGzT8igpwAA9kBrlXPukqgSsE7egpckWmq4BL7pelQNjQA3Jb0F1gjwFgmVxaVR3ddU0Ehw75YsG4GpsHwHICKh8t9vwz5/wSFwCPwvAZIw0xB9A0jijEDNr0WOobRnWlroCBJ3b7jXDsxWwXPG6kWrGSRqtnzPYLJFNHurSDm+n4TT2fH8Asj2lr/PU21wAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/puyo_i.png
// module id = d7Vi
// module chunks = 1